// tslint:disable no-any
import * as React from 'react'

/*type ComboBoxOptions = {
  [index: string]: string
}*/

export interface Props {
    className?: string
    children?: React.ReactNode
    id?: string
    color?: 'default' | 'primary' | 'secondary' | 'transparent' | 'error'
    disabled?: boolean
    onClickAction?: (x: any) => Promise<void>
    fullWidth?: boolean
    isBusy?: boolean
    onClick?: (x: any) => void
    borderColor?: string
    size?: 'tiny' | 'small' | 'medium' | 'large' | 'base'
    variant?: 'text' | 'outlined' | 'raised' | 'round'
    title?: string
    type: 'submit' | 'reset' | 'button' | undefined
}

export class Button extends React.PureComponent<Props> {
  public static defaultProps = {
    helperErrors: false,
  }

  /*constructor (props: Props) {
    super(props)
  }*/

  public disabled (): string {
    return this.props.disabled ? 'cursor-not-allowed' : 'cursor-default'
  }

  public color (): string {
    if (this.props.color === 'primary') {
      return 'text-brand'
    }

    if (this.props.color === 'secondary') {
      return 'text-brand-sec'
    }

    if (this.props.color === 'default') {
      return 'text-brand-default'
    }

    if (this.props.color === 'error') {
      return 'text-red-500'
    }

    return this.props.disabled ? 'text-gray-400' : 'text-current'
  }

  public bg (): string {
    if (this.props.disabled === true) {
      return ''
    }

    return 'hover:bg-gray-500 hover:bg-opacity-25'
  }

  public shape (): string {
    if (this.props.variant === 'round') {
      return 'p-2 rounded-full'
    }

    return 'py-2 px-4 rounded'
  }

  public size (): string {
    if (this.props.size === 'tiny') {
      return 'text-tiny'
    }

    if (this.props.size === 'small') {
      return 'text-sm'
    }

    if (this.props.size === 'large') {
      return 'text-lg'
    }

    if (this.props.size === 'base') {
      return 'text-base'
    }

    return 'text-sm'
  }

  public width (): string {
    if (this.props.fullWidth) {
      return 'w-full'
    }

    return ''
  }

  public render (): React.ReactNode {

    const style = [
      `${this.props.className}`,
      'uppercase border-none flex items-center justify-center bg-transparent',
      'cursor-pointer focus:outline-none active:outline-none',
      `${this.color()} ${this.size()} ${this.shape()}`,
      `${this.disabled()} ${this.bg()} ${this.width()}`,
    ].join(' ')

    return (
      <button
        type={this.props.type}
        disabled={this.props.disabled}
        className={style}
        id={this.props.id}
        onClick={this.props.onClick}
        title={this.props.title}
      >
        {this.props.children}
      </button>
    )
  }

}

export default Button
